import { render, staticRenderFns } from "./BCXCurrencyInput.vue?vue&type=template&id=aaed5c2a&scoped=true"
import script from "./BCXCurrencyInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXCurrencyInput.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXCurrencyInput.vue?vue&type=style&index=0&id=aaed5c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaed5c2a",
  null
  
)

export default component.exports